import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ThankYouPage from "./pages/ThankYouPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TermsConditions from "./pages/TermsConditions";
import CookieBanner from "./components/CookieBanner";

// Admin Pages
import AdminLayout from "./pages/admin/AdminLayout";
import QuoteList from "./pages/admin/QuoteList";
import QuoteCreate from "./pages/admin/QuoteCreate";
import QuoteDetail from "./pages/admin/QuoteDetail";
import Reminders from "./pages/admin/Reminders";

// Invoice System Pages
import ClientList from "./pages/admin/ClientList";
import ClientDetail from "./pages/admin/ClientDetail";
import ContractList from "./pages/admin/ContractList";
import InvoiceList from "./pages/admin/InvoiceList";
import InvoiceDetail from "./pages/admin/InvoiceDetail";
import AirbnbInvoice from "./pages/admin/AirbnbInvoice";
import OneOffInvoices from "./pages/admin/OneOffInvoices";
import JustRenovated from "./pages/admin/JustRenovated";
import JustRenovatedQuotes from "./pages/admin/JustRenovatedQuotes";
import CompaniesHouse from "./pages/admin/CompaniesHouse";
import AccountsFiling from "./pages/admin/AccountsFiling";
import Bookkeeping from "./pages/admin/Bookkeeping";
import OutreachDatabase from "./pages/admin/OutreachDatabase";
import WorkerManagement from "./pages/admin/WorkerManagement";
import WorkerSchedule from "./pages/admin/WorkerSchedule";

// Worker Portal
import WorkerApp from "./pages/worker/WorkerApp";

// Client Tracking Portal
import ClientTracking from "./pages/tracking/ClientTracking";
import PhotoGallery from "./pages/tracking/PhotoGallery";

// Public Quote Pages
import PublicQuote from "./pages/PublicQuote";
import QuoteAccepted from "./pages/QuoteAccepted";
import QuoteAutoAccept from "./pages/QuoteAutoAccept";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Landing Page */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<QuoteList />} />
            <Route path="quotes/new" element={<QuoteCreate />} />
            <Route path="quotes/:quoteId" element={<QuoteDetail />} />
            <Route path="reminders" element={<Reminders />} />
            {/* Invoice System Routes */}
            <Route path="clients" element={<ClientList />} />
            <Route path="clients/:clientId" element={<ClientDetail />} />
            <Route path="contracts" element={<ContractList />} />
            <Route path="invoices" element={<InvoiceList />} />
            <Route path="invoices/:invoiceId" element={<InvoiceDetail />} />
            <Route path="airbnb" element={<AirbnbInvoice />} />
            <Route path="oneoff" element={<OneOffInvoices />} />
            <Route path="renovated" element={<JustRenovated />} />
            <Route path="renovated-quotes" element={<JustRenovatedQuotes />} />
            <Route path="companies-house" element={<CompaniesHouse />} />
            <Route path="accounts-filing" element={<AccountsFiling />} />
            <Route path="bookkeeping" element={<Bookkeeping />} />
            <Route path="outreach" element={<OutreachDatabase />} />
            <Route path="workers" element={<WorkerManagement />} />
            <Route path="schedule" element={<WorkerSchedule />} />
          </Route>
          
          {/* Worker Portal */}
          <Route path="/worker" element={<WorkerApp />} />
          
          {/* Client Tracking Portal */}
          <Route path="/tracking/:token" element={<ClientTracking />} />
          <Route path="/gallery/:siteId" element={<PhotoGallery />} />
          
          {/* Public Quote Routes */}
          <Route path="/quote/:quoteId" element={<PublicQuote />} />
          <Route path="/quote/:quoteId/accept" element={<QuoteAutoAccept />} />
          <Route path="/quote/:quoteId/accepted" element={<QuoteAccepted />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
